import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { ProgramFilterSelectedValues } from '../../../configs/program-filter-config/filter-selected-values';
import { programFilterConfig } from '../../../configs/program-filter-config';

export const LeadProgramFilter = () => {
  return (
    <InputFilterTrigger
      renderValues={ProgramFilterSelectedValues}
      filterLabel='Program'
      config={programFilterConfig}
    />
  );
};
